import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { APP_CONFIG } from '../config/app-config.token';
import { AUTH_PORT } from '../auth/auth-port';
import { API_BASE_URL } from './api-base-url.token';

/**
 * «Una sola vez por navegación» (FE-86): mientras `redirigido` sea `true`, un 401 adicional no
 * vuelve a llamar `iniciar()`. No se repone: la navegación completa al login reemplaza la página.
 */
@Injectable({ providedIn: 'root' })
export class EntraRedireccionEstado {
  redirigido = false;
}

/**
 * En modo entra (FE-86, enmienda E-7): marca con `withCredentials` las solicitudes hacia la API
 * para que viaje la cookie de sesión, y ante un 401 que no venga de las propias rutas `/v1/auth/`
 * redirige al login una sola vez por navegación. Ya no agrega `Authorization: Bearer` ni token
 * alguno: la consola no maneja tokens, solo sigue redirecciones del backend.
 */
export const entraAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(APP_CONFIG);
  const apiBaseUrl = inject(API_BASE_URL);

  if (config.auth.modo !== 'entra' || !req.url.startsWith(apiBaseUrl)) {
    return next(req);
  }

  const conCredenciales = req.clone({ withCredentials: true });

  if (req.url.startsWith(`${apiBaseUrl}/v1/auth/`)) {
    return next(conCredenciales);
  }

  const authPort = inject(AUTH_PORT);
  const estado = inject(EntraRedireccionEstado);

  return next(conCredenciales).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && !estado.redirigido) {
        estado.redirigido = true;
        authPort.iniciar(`${window.location.pathname}${window.location.search}`);
      }
      return throwError(() => error);
    }),
  );
};
